import React, { useState } from "react";
import { Plus } from "lucide-react";
import { adminAddWorklog } from "../api";

const today = () => new Date().toISOString().slice(0, 10);
const field = "h-10 rounded-xl border border-slate-200 px-3 text-sm bg-white";

export const AdminWorklogForm = ({ bookings, onSaved }) => {
  const assigned = bookings.filter((b) => b.assigned_cleaner_id && !b.archived);
  const [f, setF] = useState({ booking: "", date: today(), hours: "", note: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.booking || !f.hours) return alert("Bitte Auftrag und Stunden angeben.");
    setBusy(true);
    try {
      await adminAddWorklog(f.booking, { date: f.date, hours: Number(f.hours), note: f.note });
      setF({ ...f, hours: "", note: "" });
      onSaved();
    } catch (err) { alert("Fehler: " + (err.response?.data?.detail || err.message)); }
    setBusy(false);
  };

  return (
    <form data-testid="admin-worklog-form" onSubmit={submit} className="bg-white rounded-2xl border border-slate-100 p-4 mb-4">
      <div className="text-sm font-semibold text-slate-700 mb-3">Stunden selbst eintragen (falls die Putzfrau es nicht macht)</div>
      <div className="flex flex-wrap items-center gap-2">
        <select data-testid="admin-worklog-booking" value={f.booking} onChange={set("booking")} className={`${field} min-w-[240px]`}>
          <option value="">Auftrag wählen…</option>
          {assigned.map((b) => <option key={b.id} value={b.id}>{b.assigned_cleaner_name} → {b.name} ({b.city})</option>)}
        </select>
        <input data-testid="admin-worklog-date" type="date" value={f.date} onChange={set("date")} className={field} />
        <input data-testid="admin-worklog-hours" type="number" min="0.25" max="24" step="0.25" placeholder="Std." value={f.hours} onChange={set("hours")} className={`${field} w-24`} />
        <input data-testid="admin-worklog-note" placeholder="Notiz (optional)" value={f.note} onChange={set("note")} className={`${field} flex-1 min-w-[160px]`} />
        <button data-testid="admin-worklog-submit" disabled={busy} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-xl bg-teal-700 text-white text-sm font-semibold hover:bg-teal-800 disabled:opacity-50">
          <Plus className="w-4 h-4" /> Eintragen
        </button>
      </div>
      {assigned.length === 0 && <p className="text-xs text-slate-400 mt-2">Noch keine Aufträge mit zugewiesener Putzfrau.</p>}
    </form>
  );
};
